// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile__3w9dq"};